import styled from 'styled-components';
import { typeScale, round } from 'core/utils';

export const Title = styled.h2`
	margin: 0;
	font-size: 24px;
	line-height: ${round(30/24)};
	margin-bottom: ${typeScale(1)};
`;

export const Subtitle = styled.p`
	margin: 0;
	font-size: 16px;
	line-height: ${round(22/16)};
`;
